var _excluded = ["data"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import mutate from "dom-mutator";
import { decrypt, getAutoExperimentChangeType, isURLTargeted, loadSDKVersion, mergeQueryStrings, promiseTimeout } from "./util.mjs";
import { configureCache, refreshFeatures, startStreaming, unsubscribe } from "./feature-repository.mjs";
import { runExperiment, evalFeature as _evalFeature, getExperimentResult, getAllStickyBucketAssignmentDocs, decryptPayload, getApiHosts as _getApiHosts, getExperimentDedupeKey, getStickyBucketAttributes } from "./core.mjs";
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var SDK_VERSION = loadSDKVersion();
export var GrowthBook = /*#__PURE__*/function () {
  // context is technically private, but some tools depend on it so we can't mangle the name

  // Properties and methods that start with "_" are mangled by Terser (saves ~150 bytes)

  function GrowthBook(options) {
    _classCallCheck(this, GrowthBook);
    options = options || {};
    // These properties are all initialized in the constructor instead of above
    // This saves ~80 bytes in the final output
    this.version = SDK_VERSION;
    this._options = this.context = options;
    this._renderer = options.renderer || null;
    this._trackedExperiments = new Set();
    this._completedChangeIds = new Set();
    this._trackedFeatures = {};
    this.debug = !!options.debug;
    this._subscriptions = new Set();
    this.ready = false;
    this._assigned = new Map();
    this._activeAutoExperiments = new Map();
    this._triggeredExpKeys = new Set();
    this._initialized = false;
    this._redirectedUrl = "";
    this._deferredTrackingCalls = new Map();
    this._autoExperimentsAllowed = !options.disableExperimentsOnLoad;
    this._destroyCallbacks = [];
    this.logs = [];
    this.log = this.log.bind(this);
    this._saveDeferredTrack = this._saveDeferredTrack.bind(this);
    this._fireSubscriptions = this._fireSubscriptions.bind(this);
    this._recordChangedId = this._recordChangedId.bind(this);
    if (options.remoteEval) {
      if (options.decryptionKey) {
        throw new Error("Encryption is not available for remoteEval");
      }
      if (!options.clientKey) {
        throw new Error("Missing clientKey");
      }
      var isGbHost = false;
      try {
        isGbHost = !!new URL(options.apiHost || "").hostname.match(/growthbook\.io$/i);
      } catch (e) {
        // ignore invalid URLs
      }
      if (isGbHost) {
        throw new Error("Cannot use remoteEval on GrowthBook Cloud");
      }
    } else {
      if (options.cacheKeyAttributes) {
        throw new Error("cacheKeyAttributes are only used for remoteEval");
      }
    }
    if (options.stickyBucketService) {
      var s = options.stickyBucketService;
      this._saveStickyBucketAssignmentDoc = function (doc) {
        return s.saveAssignments(doc);
      };
    }
    if (options.plugins) {
      var _iterator = _createForOfIteratorHelper(options.plugins),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;
          plugin(this);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    if (options.features) {
      this.ready = true;
    }
    if (isBrowser && options.enableDevMode) {
      window._growthbook = this;
      document.dispatchEvent(new Event("gbloaded"));
    }
    if (options.experiments) {
      this.ready = true;
      this._updateAllAutoExperiments();
    }

    // Hydrate sticky bucket service
    if (this._options.stickyBucketService && this._options.stickyBucketAssignmentDocs) {
      for (var key in this._options.stickyBucketAssignmentDocs) {
        var doc = this._options.stickyBucketAssignmentDocs[key];
        if (doc) {
          this._options.stickyBucketService.saveAssignments(doc).catch(function () {
            // Ignore hydration errors
          });
        }
      }
    }

    // Legacy - passing in features/experiments into the constructor instead of using init
    if (this.ready) {
      this.refreshStickyBuckets(this.getPayload());
    }
  }
  return _createClass(GrowthBook, [{
    key: "setPayload",
    value: function () {
      var _setPayload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(payload) {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this._payload = payload;
              _context.n = 1;
              return decryptPayload(payload, this._options.decryptionKey);
            case 1:
              data = _context.v;
              this._decryptedPayload = data;
              _context.n = 2;
              return this.refreshStickyBuckets(data);
            case 2:
              if (data.features) {
                this._options.features = data.features;
              }
              if (data.savedGroups) {
                this._options.savedGroups = data.savedGroups;
              }
              if (data.experiments) {
                this._options.experiments = data.experiments;
                this._updateAllAutoExperiments();
              }
              this.ready = true;
              this._render();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function setPayload(_x) {
        return _setPayload.apply(this, arguments);
      }
      return setPayload;
    }()
  }, {
    key: "initSync",
    value: function initSync(options) {
      this._initialized = true;
      var payload = options.payload;
      if (payload.encryptedExperiments || payload.encryptedFeatures) {
        throw new Error("initSync does not support encrypted payloads");
      }
      if (this._options.stickyBucketService && !this._options.stickyBucketAssignmentDocs) {
        this._options.stickyBucketAssignmentDocs = this.generateStickyBucketAssignmentDocsSync(this._options.stickyBucketService, payload);
      }
      this._payload = payload;
      this._decryptedPayload = payload;
      if (payload.features) {
        this._options.features = payload.features;
      }
      if (payload.experiments) {
        this._options.experiments = payload.experiments;
        this._updateAllAutoExperiments();
      }
      this.ready = true;
      startStreaming(this, options);
      return this;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(options) {
        var _yield$this$_refresh, data, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this._initialized = true;
              options = options || {};
              if (options.cacheSettings) {
                configureCache(options.cacheSettings);
              }
              if (!options.payload) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.setPayload(options.payload);
            case 1:
              startStreaming(this, options);
              return _context2.a(2, {
                success: true,
                source: "init"
              });
            case 2:
              _context2.n = 3;
              return this._refresh(_objectSpread(_objectSpread({}, options), {}, {
                allowStale: true
              }));
            case 3:
              _yield$this$_refresh = _context2.v;
              data = _yield$this$_refresh.data;
              res = _objectWithoutProperties(_yield$this$_refresh, _excluded);
              startStreaming(this, options);
              _context2.n = 4;
              return this.setPayload(data || {});
            case 4:
              return _context2.a(2, res);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function init(_x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }() /** @deprecated Use {@link init} */
  }, {
    key: "loadFeatures",
    value: (function () {
      var _loadFeatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(options) {
        var _this$_options$backgr;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              options = options || {};
              _context3.n = 1;
              return this.init({
                skipCache: options.skipCache,
                timeout: options.timeout,
                streaming: ((_this$_options$backgr = this._options.backgroundSync) !== null && _this$_options$backgr !== void 0 ? _this$_options$backgr : true) && (options.autoRefresh || this._options.subscribeToChanges)
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function loadFeatures(_x3) {
        return _loadFeatures.apply(this, arguments);
      }
      return loadFeatures;
    }())
  }, {
    key: "refreshFeatures",
    value: function () {
      var _refreshFeatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(options) {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this._refresh(_objectSpread(_objectSpread({}, options || {}), {}, {
                allowStale: false
              }));
            case 1:
              res = _context4.v;
              if (!res.data) {
                _context4.n = 2;
                break;
              }
              _context4.n = 2;
              return this.setPayload(res.data);
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function refreshFeatures(_x4) {
        return _refreshFeatures.apply(this, arguments);
      }
      return refreshFeatures;
    }()
  }, {
    key: "getApiInfo",
    value: function getApiInfo() {
      return [this.getApiHosts().apiHost, this.getClientKey()];
    }
  }, {
    key: "getApiHosts",
    value: function getApiHosts() {
      return _getApiHosts(this._options);
    }
  }, {
    key: "getClientKey",
    value: function getClientKey() {
      return this._options.clientKey || "";
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      return this._payload || {
        features: this.getFeatures(),
        experiments: this.getExperiments()
      };
    }
  }, {
    key: "getDecryptedPayload",
    value: function getDecryptedPayload() {
      return this._decryptedPayload || this.getPayload();
    }
  }, {
    key: "isRemoteEval",
    value: function isRemoteEval() {
      return this._options.remoteEval || false;
    }
  }, {
    key: "getCacheKeyAttributes",
    value: function getCacheKeyAttributes() {
      return this._options.cacheKeyAttributes;
    }
  }, {
    key: "_refresh",
    value: function () {
      var _refresh2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref) {
        var _ref2;
        var timeout, skipCache, allowStale, streaming;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              timeout = _ref.timeout, skipCache = _ref.skipCache, allowStale = _ref.allowStale, streaming = _ref.streaming;
              if (this._options.clientKey) {
                _context5.n = 1;
                break;
              }
              throw new Error("Missing clientKey");
            case 1:
              return _context5.a(2, refreshFeatures({
                instance: this,
                timeout: timeout,
                skipCache: skipCache || this._options.disableCache,
                allowStale: allowStale,
                backgroundSync: (_ref2 = streaming !== null && streaming !== void 0 ? streaming : this._options.backgroundSync) !== null && _ref2 !== void 0 ? _ref2 : true
              }));
          }
        }, _callee5, this);
      }));
      function _refresh(_x5) {
        return _refresh2.apply(this, arguments);
      }
      return _refresh;
    }()
  }, {
    key: "_render",
    value: function _render() {
      if (this._renderer) {
        try {
          this._renderer();
        } catch (e) {
          console.error("Failed to render", e);
        }
      }
    }

    /** @deprecated Use {@link setPayload} */
  }, {
    key: "setFeatures",
    value: function setFeatures(features) {
      this._options.features = features;
      this.ready = true;
      this._render();
    }

    /** @deprecated Use {@link setPayload} */
  }, {
    key: "setEncryptedFeatures",
    value: (function () {
      var _setEncryptedFeatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(encryptedString, decryptionKey, subtle) {
        var featuresJSON;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return decrypt(encryptedString, decryptionKey || this._options.decryptionKey, subtle);
            case 1:
              featuresJSON = _context6.v;
              this.setFeatures(JSON.parse(featuresJSON));
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function setEncryptedFeatures(_x6, _x7, _x8) {
        return _setEncryptedFeatures.apply(this, arguments);
      }
      return setEncryptedFeatures;
    }() /** @deprecated Use {@link setPayload} */)
  }, {
    key: "setExperiments",
    value: function setExperiments(experiments) {
      this._options.experiments = experiments;
      this.ready = true;
      this._updateAllAutoExperiments();
    }

    /** @deprecated Use {@link setPayload} */
  }, {
    key: "setEncryptedExperiments",
    value: (function () {
      var _setEncryptedExperiments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(encryptedString, decryptionKey, subtle) {
        var experimentsJSON;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return decrypt(encryptedString, decryptionKey || this._options.decryptionKey, subtle);
            case 1:
              experimentsJSON = _context7.v;
              this.setExperiments(JSON.parse(experimentsJSON));
            case 2:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function setEncryptedExperiments(_x9, _x0, _x1) {
        return _setEncryptedExperiments.apply(this, arguments);
      }
      return setEncryptedExperiments;
    }())
  }, {
    key: "setAttributes",
    value: function () {
      var _setAttributes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(attributes) {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              this._options.attributes = attributes;
              if (!this._options.stickyBucketService) {
                _context8.n = 1;
                break;
              }
              _context8.n = 1;
              return this.refreshStickyBuckets();
            case 1:
              if (!this._options.remoteEval) {
                _context8.n = 3;
                break;
              }
              _context8.n = 2;
              return this._refreshForRemoteEval();
            case 2:
              return _context8.a(2);
            case 3:
              this._render();
              this._updateAllAutoExperiments();
            case 4:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function setAttributes(_x10) {
        return _setAttributes.apply(this, arguments);
      }
      return setAttributes;
    }()
  }, {
    key: "updateAttributes",
    value: function () {
      var _updateAttributes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(attributes) {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              return _context9.a(2, this.setAttributes(_objectSpread(_objectSpread({}, this._options.attributes), attributes)));
          }
        }, _callee9, this);
      }));
      function updateAttributes(_x11) {
        return _updateAttributes.apply(this, arguments);
      }
      return updateAttributes;
    }()
  }, {
    key: "setAttributeOverrides",
    value: function () {
      var _setAttributeOverrides = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(overrides) {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              this._options.attributeOverrides = overrides;
              if (!this._options.stickyBucketService) {
                _context0.n = 1;
                break;
              }
              _context0.n = 1;
              return this.refreshStickyBuckets();
            case 1:
              if (!this._options.remoteEval) {
                _context0.n = 3;
                break;
              }
              _context0.n = 2;
              return this._refreshForRemoteEval();
            case 2:
              return _context0.a(2);
            case 3:
              this._render();
              this._updateAllAutoExperiments();
            case 4:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function setAttributeOverrides(_x12) {
        return _setAttributeOverrides.apply(this, arguments);
      }
      return setAttributeOverrides;
    }()
  }, {
    key: "setForcedVariations",
    value: function () {
      var _setForcedVariations = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(vars) {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              this._options.forcedVariations = vars || {};
              if (!this._options.remoteEval) {
                _context1.n = 2;
                break;
              }
              _context1.n = 1;
              return this._refreshForRemoteEval();
            case 1:
              return _context1.a(2);
            case 2:
              this._render();
              this._updateAllAutoExperiments();
            case 3:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function setForcedVariations(_x13) {
        return _setForcedVariations.apply(this, arguments);
      }
      return setForcedVariations;
    }() // eslint-disable-next-line
  }, {
    key: "setForcedFeatures",
    value: function setForcedFeatures(map) {
      this._options.forcedFeatureValues = map;
      this._render();
    }
  }, {
    key: "setURL",
    value: function () {
      var _setURL = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(url) {
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              if (!(url === this._options.url)) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2);
            case 1:
              this._options.url = url;
              this._redirectedUrl = "";
              if (!this._options.remoteEval) {
                _context10.n = 3;
                break;
              }
              _context10.n = 2;
              return this._refreshForRemoteEval();
            case 2:
              this._updateAllAutoExperiments(true);
              return _context10.a(2);
            case 3:
              this._updateAllAutoExperiments(true);
            case 4:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function setURL(_x14) {
        return _setURL.apply(this, arguments);
      }
      return setURL;
    }()
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return _objectSpread(_objectSpread({}, this._options.attributes), this._options.attributeOverrides);
    }
  }, {
    key: "getForcedVariations",
    value: function getForcedVariations() {
      return this._options.forcedVariations || {};
    }
  }, {
    key: "getForcedFeatures",
    value: function getForcedFeatures() {
      // eslint-disable-next-line
      return this._options.forcedFeatureValues || new Map();
    }
  }, {
    key: "getStickyBucketAssignmentDocs",
    value: function getStickyBucketAssignmentDocs() {
      return this._options.stickyBucketAssignmentDocs || {};
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      return this._options.url || "";
    }
  }, {
    key: "getFeatures",
    value: function getFeatures() {
      return this._options.features || {};
    }
  }, {
    key: "getExperiments",
    value: function getExperiments() {
      return this._options.experiments || [];
    }
  }, {
    key: "getCompletedChangeIds",
    value: function getCompletedChangeIds() {
      return Array.from(this._completedChangeIds);
    }
  }, {
    key: "subscribe",
    value: function subscribe(cb) {
      var _this = this;
      this._subscriptions.add(cb);
      return function () {
        _this._subscriptions.delete(cb);
      };
    }
  }, {
    key: "_refreshForRemoteEval",
    value: function () {
      var _refreshForRemoteEval2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var res;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              if (this._options.remoteEval) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2);
            case 1:
              if (this._initialized) {
                _context11.n = 2;
                break;
              }
              return _context11.a(2);
            case 2:
              _context11.n = 3;
              return this._refresh({
                allowStale: false
              });
            case 3:
              res = _context11.v;
              if (!res.data) {
                _context11.n = 4;
                break;
              }
              _context11.n = 4;
              return this.setPayload(res.data);
            case 4:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function _refreshForRemoteEval() {
        return _refreshForRemoteEval2.apply(this, arguments);
      }
      return _refreshForRemoteEval;
    }()
  }, {
    key: "getAllResults",
    value: function getAllResults() {
      return new Map(this._assigned);
    }
  }, {
    key: "onDestroy",
    value: function onDestroy(cb) {
      this._destroyCallbacks.push(cb);
    }
  }, {
    key: "isDestroyed",
    value: function isDestroyed() {
      return !!this._destroyed;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._destroyed = true;

      // Custom callbacks
      // Do this first in case it needs access to the below data that is cleared
      this._destroyCallbacks.forEach(function (cb) {
        try {
          cb();
        } catch (e) {
          console.error(e);
        }
      });

      // Release references to save memory
      this._subscriptions.clear();
      this._assigned.clear();
      this._trackedExperiments.clear();
      this._completedChangeIds.clear();
      this._deferredTrackingCalls.clear();
      this._trackedFeatures = {};
      this._destroyCallbacks = [];
      this._payload = undefined;
      this._saveStickyBucketAssignmentDoc = undefined;
      unsubscribe(this);
      this.logs = [];
      if (isBrowser && window._growthbook === this) {
        delete window._growthbook;
      }

      // Undo any active auto experiments
      this._activeAutoExperiments.forEach(function (exp) {
        exp.undo();
      });
      this._activeAutoExperiments.clear();
      this._triggeredExpKeys.clear();
    }
  }, {
    key: "setRenderer",
    value: function setRenderer(renderer) {
      this._renderer = renderer;
    }
  }, {
    key: "forceVariation",
    value: function forceVariation(key, variation) {
      this._options.forcedVariations = this._options.forcedVariations || {};
      this._options.forcedVariations[key] = variation;
      if (this._options.remoteEval) {
        this._refreshForRemoteEval();
        return;
      }
      this._updateAllAutoExperiments();
      this._render();
    }
  }, {
    key: "run",
    value: function run(experiment) {
      var _runExperiment = runExperiment(experiment, null, this._getEvalContext()),
        result = _runExperiment.result;
      this._fireSubscriptions(experiment, result);
      return result;
    }
  }, {
    key: "triggerExperiment",
    value: function triggerExperiment(key) {
      var _this2 = this;
      this._triggeredExpKeys.add(key);
      if (!this._options.experiments) return null;
      var experiments = this._options.experiments.filter(function (exp) {
        return exp.key === key;
      });
      return experiments.map(function (exp) {
        return _this2._runAutoExperiment(exp);
      }).filter(function (res) {
        return res !== null;
      });
    }
  }, {
    key: "triggerAutoExperiments",
    value: function triggerAutoExperiments() {
      this._autoExperimentsAllowed = true;
      this._updateAllAutoExperiments(true);
    }
  }, {
    key: "_getEvalContext",
    value: function _getEvalContext() {
      return {
        user: this._getUserContext(),
        global: this._getGlobalContext(),
        stack: {
          evaluatedFeatures: new Set()
        }
      };
    }
  }, {
    key: "_getUserContext",
    value: function _getUserContext() {
      return {
        attributes: this._options.user ? _objectSpread(_objectSpread({}, this._options.user), this._options.attributes) : this._options.attributes,
        enableDevMode: this._options.enableDevMode,
        blockedChangeIds: this._options.blockedChangeIds,
        stickyBucketAssignmentDocs: this._options.stickyBucketAssignmentDocs,
        url: this._getContextUrl(),
        forcedVariations: this._options.forcedVariations,
        forcedFeatureValues: this._options.forcedFeatureValues,
        attributeOverrides: this._options.attributeOverrides,
        saveStickyBucketAssignmentDoc: this._saveStickyBucketAssignmentDoc,
        trackingCallback: this._options.trackingCallback,
        onFeatureUsage: this._options.onFeatureUsage,
        devLogs: this.logs,
        trackedExperiments: this._trackedExperiments,
        trackedFeatureUsage: this._trackedFeatures
      };
    }
  }, {
    key: "_getGlobalContext",
    value: function _getGlobalContext() {
      return {
        features: this._options.features,
        experiments: this._options.experiments,
        log: this.log,
        enabled: this._options.enabled,
        qaMode: this._options.qaMode,
        savedGroups: this._options.savedGroups,
        groups: this._options.groups,
        overrides: this._options.overrides,
        onExperimentEval: this._subscriptions.size > 0 ? this._fireSubscriptions : undefined,
        recordChangeId: this._recordChangedId,
        saveDeferredTrack: this._saveDeferredTrack,
        eventLogger: this._options.eventLogger
      };
    }
  }, {
    key: "_runAutoExperiment",
    value: function _runAutoExperiment(experiment, forceRerun) {
      var _this3 = this;
      var existing = this._activeAutoExperiments.get(experiment);

      // If this is a manual experiment and it's not already running, skip
      if (experiment.manual && !this._triggeredExpKeys.has(experiment.key) && !existing) return null;

      // Check if this particular experiment is blocked by options settings
      // For example, if all visualEditor experiments are disabled
      var isBlocked = this._isAutoExperimentBlockedByContext(experiment);
      if (isBlocked) {
        process.env.NODE_ENV !== "production" && this.log("Auto experiment blocked", {
          id: experiment.key
        });
      }
      var result;
      var trackingCall;
      // Run the experiment (if blocked exclude)
      if (isBlocked) {
        result = getExperimentResult(this._getEvalContext(), experiment, -1, false, "");
      } else {
        var _runExperiment2 = runExperiment(experiment, null, this._getEvalContext());
        result = _runExperiment2.result;
        trackingCall = _runExperiment2.trackingCall;
        this._fireSubscriptions(experiment, result);
      }

      // A hash to quickly tell if the assigned value changed
      var valueHash = JSON.stringify(result.value);

      // If the changes are already active, no need to re-apply them
      if (!forceRerun && result.inExperiment && existing && existing.valueHash === valueHash) {
        return result;
      }

      // Undo any existing changes
      if (existing) this._undoActiveAutoExperiment(experiment);

      // Apply new changes
      if (result.inExperiment) {
        var changeType = getAutoExperimentChangeType(experiment);
        if (changeType === "redirect" && result.value.urlRedirect && experiment.urlPatterns) {
          var url = experiment.persistQueryString ? mergeQueryStrings(this._getContextUrl(), result.value.urlRedirect) : result.value.urlRedirect;
          if (isURLTargeted(url, experiment.urlPatterns)) {
            this.log("Skipping redirect because original URL matches redirect URL", {
              id: experiment.key
            });
            return result;
          }
          this._redirectedUrl = url;
          var _this$_getNavigateFun = this._getNavigateFunction(),
            navigate = _this$_getNavigateFun.navigate,
            delay = _this$_getNavigateFun.delay;
          if (navigate) {
            if (isBrowser) {
              var _this$_options$maxNav;
              // Wait for the possibly-async tracking callback, bound by min and max delays
              Promise.all([].concat(_toConsumableArray(trackingCall ? [promiseTimeout(trackingCall, (_this$_options$maxNav = this._options.maxNavigateDelay) !== null && _this$_options$maxNav !== void 0 ? _this$_options$maxNav : 1000)] : []), [new Promise(function (resolve) {
                var _this3$_options$navig;
                return window.setTimeout(resolve, (_this3$_options$navig = _this3._options.navigateDelay) !== null && _this3$_options$navig !== void 0 ? _this3$_options$navig : delay);
              })])).then(function () {
                try {
                  navigate(url);
                } catch (e) {
                  console.error(e);
                }
              });
            } else {
              try {
                navigate(url);
              } catch (e) {
                console.error(e);
              }
            }
          }
        } else if (changeType === "visual") {
          var undo = this._options.applyDomChangesCallback ? this._options.applyDomChangesCallback(result.value) : this._applyDOMChanges(result.value);
          if (undo) {
            this._activeAutoExperiments.set(experiment, {
              undo: undo,
              valueHash: valueHash
            });
          }
        }
      }
      return result;
    }
  }, {
    key: "_undoActiveAutoExperiment",
    value: function _undoActiveAutoExperiment(exp) {
      var data = this._activeAutoExperiments.get(exp);
      if (data) {
        data.undo();
        this._activeAutoExperiments.delete(exp);
      }
    }
  }, {
    key: "_updateAllAutoExperiments",
    value: function _updateAllAutoExperiments(forceRerun) {
      var _this4 = this;
      if (!this._autoExperimentsAllowed) return;
      var experiments = this._options.experiments || [];

      // Stop any experiments that are no longer defined
      var keys = new Set(experiments);
      this._activeAutoExperiments.forEach(function (v, k) {
        if (!keys.has(k)) {
          v.undo();
          _this4._activeAutoExperiments.delete(k);
        }
      });

      // Re-run all new/updated experiments
      var _iterator2 = _createForOfIteratorHelper(experiments),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var exp = _step2.value;
          var result = this._runAutoExperiment(exp, forceRerun);

          // Once you're in a redirect experiment, break out of the loop and don't run any further experiments
          if (result !== null && result !== void 0 && result.inExperiment && getAutoExperimentChangeType(exp) === "redirect") {
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "_fireSubscriptions",
    value: function _fireSubscriptions(experiment, result) {
      var key = experiment.key;

      // If assigned variation has changed, fire subscriptions
      var prev = this._assigned.get(key);
      // TODO: what if the experiment definition has changed?
      if (!prev || prev.result.inExperiment !== result.inExperiment || prev.result.variationId !== result.variationId) {
        this._assigned.set(key, {
          experiment: experiment,
          result: result
        });
        this._subscriptions.forEach(function (cb) {
          try {
            cb(experiment, result);
          } catch (e) {
            console.error(e);
          }
        });
      }
    }
  }, {
    key: "_recordChangedId",
    value: function _recordChangedId(id) {
      this._completedChangeIds.add(id);
    }
  }, {
    key: "isOn",
    value: function isOn(key) {
      return this.evalFeature(key).on;
    }
  }, {
    key: "isOff",
    value: function isOff(key) {
      return this.evalFeature(key).off;
    }
  }, {
    key: "getFeatureValue",
    value: function getFeatureValue(key, defaultValue) {
      var value = this.evalFeature(key).value;
      return value === null ? defaultValue : value;
    }

    /**
     * @deprecated Use {@link evalFeature}
     * @param id
     */
    // eslint-disable-next-line
  }, {
    key: "feature",
    value: function feature(id) {
      return this.evalFeature(id);
    }
  }, {
    key: "evalFeature",
    value: function evalFeature(id) {
      return _evalFeature(id, this._getEvalContext());
    }
  }, {
    key: "log",
    value: function log(msg, ctx) {
      if (!this.debug) return;
      if (this._options.log) this._options.log(msg, ctx);else console.log(msg, ctx);
    }
  }, {
    key: "getDeferredTrackingCalls",
    value: function getDeferredTrackingCalls() {
      return Array.from(this._deferredTrackingCalls.values());
    }
  }, {
    key: "setDeferredTrackingCalls",
    value: function setDeferredTrackingCalls(calls) {
      this._deferredTrackingCalls = new Map(calls.filter(function (c) {
        return c && c.experiment && c.result;
      }).map(function (c) {
        return [getExperimentDedupeKey(c.experiment, c.result), c];
      }));
    }
  }, {
    key: "fireDeferredTrackingCalls",
    value: function () {
      var _fireDeferredTrackingCalls = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var _this5 = this;
        var promises;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              if (this._options.trackingCallback) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2);
            case 1:
              promises = [];
              this._deferredTrackingCalls.forEach(function (call) {
                if (!call || !call.experiment || !call.result) {
                  console.error("Invalid deferred tracking call", {
                    call: call
                  });
                } else {
                  promises.push(_this5._options.trackingCallback(call.experiment, call.result));
                }
              });
              this._deferredTrackingCalls.clear();
              _context12.n = 2;
              return Promise.all(promises);
            case 2:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function fireDeferredTrackingCalls() {
        return _fireDeferredTrackingCalls.apply(this, arguments);
      }
      return fireDeferredTrackingCalls;
    }()
  }, {
    key: "setTrackingCallback",
    value: function setTrackingCallback(callback) {
      this._options.trackingCallback = callback;
      this.fireDeferredTrackingCalls();
    }
  }, {
    key: "setEventLogger",
    value: function setEventLogger(logger) {
      this._options.eventLogger = logger;
    }
  }, {
    key: "logEvent",
    value: function () {
      var _logEvent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(eventName, properties) {
        var _t;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              if (!this._destroyed) {
                _context13.n = 1;
                break;
              }
              console.error("Cannot log event to destroyed GrowthBook instance");
              return _context13.a(2);
            case 1:
              if (this._options.enableDevMode) {
                this.logs.push({
                  eventName: eventName,
                  properties: properties,
                  timestamp: Date.now().toString(),
                  logType: "event"
                });
              }
              if (!this._options.eventLogger) {
                _context13.n = 6;
                break;
              }
              _context13.p = 2;
              _context13.n = 3;
              return this._options.eventLogger(eventName, properties || {}, this._getUserContext());
            case 3:
              _context13.n = 5;
              break;
            case 4:
              _context13.p = 4;
              _t = _context13.v;
              console.error(_t);
            case 5:
              _context13.n = 7;
              break;
            case 6:
              console.error("No event logger configured");
            case 7:
              return _context13.a(2);
          }
        }, _callee13, this, [[2, 4]]);
      }));
      function logEvent(_x15, _x16) {
        return _logEvent.apply(this, arguments);
      }
      return logEvent;
    }()
  }, {
    key: "_saveDeferredTrack",
    value: function _saveDeferredTrack(data) {
      this._deferredTrackingCalls.set(getExperimentDedupeKey(data.experiment, data.result), data);
    }
  }, {
    key: "_getContextUrl",
    value: function _getContextUrl() {
      return this._options.url || (isBrowser ? window.location.href : "");
    }
  }, {
    key: "_isAutoExperimentBlockedByContext",
    value: function _isAutoExperimentBlockedByContext(experiment) {
      var changeType = getAutoExperimentChangeType(experiment);
      if (changeType === "visual") {
        if (this._options.disableVisualExperiments) return true;
        if (this._options.disableJsInjection) {
          if (experiment.variations.some(function (v) {
            return v.js;
          })) {
            return true;
          }
        }
      } else if (changeType === "redirect") {
        if (this._options.disableUrlRedirectExperiments) return true;

        // Validate URLs
        try {
          var current = new URL(this._getContextUrl());
          var _iterator3 = _createForOfIteratorHelper(experiment.variations),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var v = _step3.value;
              if (!v || !v.urlRedirect) continue;
              var url = new URL(v.urlRedirect);

              // If we're blocking cross origin redirects, block if the protocol or host is different
              if (this._options.disableCrossOriginUrlRedirectExperiments) {
                if (url.protocol !== current.protocol) return true;
                if (url.host !== current.host) return true;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        } catch (e) {
          // Problem parsing one of the URLs
          this.log("Error parsing current or redirect URL", {
            id: experiment.key,
            error: e
          });
          return true;
        }
      } else {
        // Block any unknown changeTypes
        return true;
      }
      if (experiment.changeId && (this._options.blockedChangeIds || []).includes(experiment.changeId)) {
        return true;
      }
      return false;
    }
  }, {
    key: "getRedirectUrl",
    value: function getRedirectUrl() {
      return this._redirectedUrl;
    }
  }, {
    key: "_getNavigateFunction",
    value: function _getNavigateFunction() {
      if (this._options.navigate) {
        return {
          navigate: this._options.navigate,
          delay: 0
        };
      } else if (isBrowser) {
        return {
          navigate: function navigate(url) {
            window.location.replace(url);
          },
          delay: 100
        };
      }
      return {
        navigate: null,
        delay: 0
      };
    }
  }, {
    key: "_applyDOMChanges",
    value: function _applyDOMChanges(changes) {
      if (!isBrowser) return;
      var undo = [];
      if (changes.css) {
        var s = document.createElement("style");
        s.innerHTML = changes.css;
        document.head.appendChild(s);
        undo.push(function () {
          return s.remove();
        });
      }
      if (changes.js) {
        var script = document.createElement("script");
        script.innerHTML = changes.js;
        if (this._options.jsInjectionNonce) {
          script.nonce = this._options.jsInjectionNonce;
        }
        document.head.appendChild(script);
        undo.push(function () {
          return script.remove();
        });
      }
      if (changes.domMutations) {
        changes.domMutations.forEach(function (mutation) {
          undo.push(mutate.declarative(mutation).revert);
        });
      }
      return function () {
        undo.forEach(function (fn) {
          return fn();
        });
      };
    }
  }, {
    key: "refreshStickyBuckets",
    value: function () {
      var _refreshStickyBuckets = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(data) {
        var ctx, docs;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              if (!this._options.stickyBucketService) {
                _context14.n = 2;
                break;
              }
              ctx = this._getEvalContext();
              _context14.n = 1;
              return getAllStickyBucketAssignmentDocs(ctx, this._options.stickyBucketService, data);
            case 1:
              docs = _context14.v;
              this._options.stickyBucketAssignmentDocs = docs;
            case 2:
              return _context14.a(2);
          }
        }, _callee14, this);
      }));
      function refreshStickyBuckets(_x17) {
        return _refreshStickyBuckets.apply(this, arguments);
      }
      return refreshStickyBuckets;
    }()
  }, {
    key: "generateStickyBucketAssignmentDocsSync",
    value: function generateStickyBucketAssignmentDocsSync(stickyBucketService, payload) {
      if (!("getAllAssignmentsSync" in stickyBucketService)) {
        console.error("generating StickyBucketAssignmentDocs docs requires StickyBucketServiceSync");
        return;
      }
      var ctx = this._getEvalContext();
      var attributes = getStickyBucketAttributes(ctx, payload);
      return stickyBucketService.getAllAssignmentsSync(attributes);
    }
  }, {
    key: "inDevMode",
    value: function inDevMode() {
      return !!this._options.enableDevMode;
    }
  }]);
}();
export function prefetchPayload(_x18) {
  return _prefetchPayload.apply(this, arguments);
}
function _prefetchPayload() {
  _prefetchPayload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(options) {
    var instance;
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          // Create a temporary instance, just to fetch the payload
          instance = new GrowthBook(options);
          _context15.n = 1;
          return refreshFeatures({
            instance: instance,
            skipCache: options.skipCache,
            allowStale: false,
            backgroundSync: options.streaming
          });
        case 1:
          instance.destroy();
        case 2:
          return _context15.a(2);
      }
    }, _callee15);
  }));
  return _prefetchPayload.apply(this, arguments);
}